import { MainMap } from './Shared/Map/MainMap';
import { FeatureType, IMapInteractionConfig, IFeaturesRequest, MenuType } from './Shared/Models/UtilityModels';
import * as toastr from "toastr";

import * as events from './Shared/Bus/Bus';
import { Notification } from './Shared/Notification/Notification';
import * as AuthModel from './Shared/Models/AuthModel';
import { SelectList, SelectListOptions } from './Shared/SelectList/SelectList';

import { ReportAnIssueMyIssues } from './ReportAnIssue/ReportAnIssueMyIssues';
import { ReportAnIssueNewIssue } from './ReportAnIssue/ReportAnIssueNewIssue';
import { Photos } from './Shared/Photos/Photos';
import { OfficerMapRecordList } from './OfficerMap/OfficerMapRecordList';
import { OfficerMapMapSelect } from './OfficerMap/OfficerMapMapSelect';
import { Tasks } from './Shared/Tasks/Tasks';
import { Audit } from './Shared/Audit/Audit';
import { Activity } from './Shared/Activity/Activity';
import { Search } from './Shared/Search/Search';
import { Land } from './Shared/Land/Entity_Land';
import { Infra } from './Shared/Infra/Entity_Infra';
import { Path } from './Shared/Path/Entity_Path';
import { Routes } from './Shared/Route/Entity_Routes';
import { Maint } from './Shared/Maint/Entity_Maint';
import { TaskManagementRecordList } from './TaskManagement/TaskManagementRecordList';
import { LegalEvents } from './Legal/LegalEvents';
import { Consultations } from './Consultations/Consultations';
import { MyTasksRecordList } from './MyTasks/MyTasksRecordList';
import { SubmissionList } from './Submissions/SubmissionList';
import { Contacts } from './Shared/Contacts/Contacts';
import { Annotations } from './Annotations/Annotations';
import { TRO } from './TRO/TRO';
import { ConditionSurvey } from './ConditionSurvey/ConditionSurvey';
import { Reports } from './Reports/Reports';
import { Help } from './Shared/Help/Help';
import { LocalStorageSettingsModel } from './Shared/Models/LocalStorageSettingsModel';
import { MainAppConfigModel, OpenInfoPanel } from './Shared/Models/MainAppConfigModels';
import { ContactListConfig } from './Shared/Contacts/ContactsModels';
import { HelpType } from './Shared/Help/HelpModels';
import { Utilities, ModalAction, CollapseAction } from './Shared/Utility/Utilities';
import { Popovers } from './Shared/Utility/Popovers';
import * as mainDOMRefs from './Shared/Main/MainDOMRefs';
import { SystemType, ReportModel } from './Reports/ReportsModels';
import { MapDrawGeometry, NewMapGeometryResult } from './Shared/Map/MapDrawGeometry';
import { MainEvents } from './Shared/Main/MainEvents';
import { MainResetEvents } from './Shared/Main/MainResetEvents';

// Instantiate on doc ready
$(document).ready(function () {
    let ele = $("#CAMSMainPage");
    if (ele.length === 1) {
        let map = new MainApp("officerMapContainer");
    } else {
        let ele = $("#reportsTestHarness");
        if (ele.length === 1) {
            let report = new Reports();
        }
    }
});

// Declarations
declare var G_IsMobile: Boolean;
declare global {
    interface Window {
        G_SITEFOLDERNAME: string;
    }
}

export class MainApp {
    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private authModel: AuthModel.IAuthModel = { policies: [] };
    private mainAppConfigModel: MainAppConfigModel;
    private mainMap: MainMap;
    private selectList: SelectList;
    private maint: Maint;
    private routes: Routes;
    private path: Path;
    private infra: Infra;
    private land: Land;
    private officerMapRecordList: OfficerMapRecordList;
    private taskManagementRecordList: TaskManagementRecordList;
    private legalEvents: LegalEvents;
    private consultations: Consultations;
    private officerMapMapSelect: OfficerMapMapSelect;
    private myTasksRecordList: MyTasksRecordList;
    private tasks: Tasks;
    private activity: Activity;
    private audit: Audit;
    private search: Search;
    private photos: Photos;
    private contacts: Contacts;
    private annotations: Annotations;
    private notification: Notification;
    private submissionList: SubmissionList;
    private reportAnIssueMyIssues: ReportAnIssueMyIssues; 
    private reportAnIssueNewIssue: ReportAnIssueNewIssue;
    private help: Help;
    private reports: Reports;
    private TRO: TRO;
    private ConditionSurvey: ConditionSurvey;
    private MapDrawGeometry: MapDrawGeometry;
    private MainEvents: MainEvents;
    private MainResetEvents: MainResetEvents;

    private eventMultipleFeaturesSelectedUnsubscribe;
    private eventRectangleSelectionCompleteUnsubscribe;

    private defaultSelectListButtons: SelectListOptions = { showMapHighlightBtn: true, showMapEditBtn: true, showAddSelectionBtn: false, showDetailsBtn: true, showEditAttributeBtn: true, showAnnotationBtn: false, showDeleteBtn: true };
    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    //Constructor
    public constructor(mapDOMID: string) {
        const self = this;
        // Get view model data from the Razor page
        this.authModel = Utilities.GetControl(mainDOMRefs.jqc.authModel).data("authmodel");
        this.mainAppConfigModel = Utilities.GetControl(mainDOMRefs.jqc.mainAppConfigModel).data("mainappconfigmodel");

        // Events after the maion page load completes
        events.bus.subscribe(events.eventMainPageLoadComplete, m => { self.onMainPageLoadCompleted(); });

        // Initialize the main page
        this.initLocalStorage();
        this.initComponents(mapDOMID);
        this.initToolbarButtons();
        this.initEvents();

        // Check the config package, menu type to be selected
        if (self.mainAppConfigModel.openInfoPanel != null
                && self.mainAppConfigModel.openInfoPanel.menuType != null
                && self.mainAppConfigModel.openInfoPanel.menuType != MenuType.none) {
            self.openMainMenu(self.mainAppConfigModel.openInfoPanel.menuType);
            self.mainAppConfigModel.openInfoPanel = null; // reset here so it doesn't keep firing
        }

        // Init buttons
        this.initHeaderButtons();
        this.help.initialize();

        // Resize map window based on headers and footers
        this.resizeMainContentDiv();
        window.addEventListener("resize", function (e) {
            self.resizeMainContentDiv();
        });
    }

    // ----------------------------------------------------------- //
    // INIT
    private initComponents = (mapDOMID: string): void => {
        let self = this;

        // Instantiate components
        this.notification = new Notification();
        this.mainMap = new MainMap(mapDOMID, this.authModel, this.mainAppConfigModel.mapConfig);
        this.selectList = new SelectList(this.mainMap.map, self.defaultSelectListButtons);
        this.officerMapMapSelect = new OfficerMapMapSelect(this.mainMap.map, this.authModel);
        this.maint = new Maint(this.mainMap.map, this.mainAppConfigModel.mapConfig);
        this.routes = new Routes(this.mainMap.map, this.authModel);
        this.path = new Path(this.mainMap.map, this.authModel);
        this.infra = new Infra(this.mainMap.map, this.authModel, this.mainAppConfigModel.mapConfig);
        this.land = new Land(this.mainMap.map, this.authModel);
        this.tasks = new Tasks(this.mainMap.map, this.authModel);
        this.officerMapRecordList = new OfficerMapRecordList(this.mainMap.map, this.authModel);
        if (self.authModel.policies.find(p => p == AuthModel.CAMSTaskManagement)) this.taskManagementRecordList = new TaskManagementRecordList();
        if (self.authModel.policies.find(p => p == AuthModel.CAMSLegal)) this.legalEvents = new LegalEvents();
        if (self.authModel.policies.find(p => p == AuthModel.CAMSConsultations)) this.consultations = new Consultations(this.authModel.contactRef);
        this.myTasksRecordList = new MyTasksRecordList();
        this.search = new Search();
        this.photos = new Photos();
        this.contacts = new Contacts();
        this.activity = new Activity();
        this.audit = new Audit();
        this.annotations = new Annotations();
        this.submissionList = new SubmissionList(this.mainMap.map);
        this.reportAnIssueMyIssues = new ReportAnIssueMyIssues(this.mainMap.map);
        this.reportAnIssueNewIssue = new ReportAnIssueNewIssue(this.mainMap.map, this.authModel, this.mainAppConfigModel.mapConfig);
        this.help = new Help();
        this.reports = new Reports();
        this.TRO = new TRO(this.mainMap.map);
        this.ConditionSurvey = new ConditionSurvey(this.authModel);
        this.MapDrawGeometry = new MapDrawGeometry(this.mainMap.map, this.mainAppConfigModel.mapConfig);
    }

    private initEvents = (): void => {
        let self = this;

        // Reset events
        this.MainResetEvents = new MainResetEvents(
            this.eventMultipleFeaturesSelectedUnsubscribe, this.eventRectangleSelectionCompleteUnsubscribe, this.annotations,
        );

        // Initialze dvents
        this.MainEvents = new MainEvents(
            this.activity, this.audit, this.mainMap, this.MapDrawGeometry,
            this.officerMapMapSelect, this.selectList, this.maint, this.routes,
            this.infra, this.land, this.myTasksRecordList, this.tasks, this.taskManagementRecordList,
            this.contacts, this.consultations, this.ConditionSurvey, this.legalEvents, this.annotations,
            this.reports, this.officerMapRecordList, this.TRO, this.photos, this.path, this.notification,
            this.MainResetEvents
        );
    }

    private initToolbarButtons = (): void => {
        const self = this;

        // ***************************** Main Buttons ***************************** //
        // Zoom //
        Utilities.GetControl(mainDOMRefs.jqc.zoomBtn).on("click", function () {
            self.mainMap.zoomToMyLocation(true);
        });

        // LEGEND //
        Utilities.GetControl(mainDOMRefs.jqc.legendBtn).on("click", function () {
            self.mainMap.showLegendModal();
        });

        // LAYERS //
        Utilities.GetControl(mainDOMRefs.jqc.layersBtn).on("click", function () {
            //events.bus.publish(events.eventResetAllButtons(false));
            //events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventResetRightPanels());
            $(this).addClass('mapActionSelected');
            Utilities.GetControl(mainDOMRefs.jqc.layerPanel).addClass('show');
        });

        // LOCATION INFO //
        Utilities.GetControl(mainDOMRefs.jqc.mapInfoSelectBtn).on("click", function () {
            events.bus.publish(events.eventResetAllButtons(false));
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventClearAllHighlights());
            events.bus.publish(events.eventClearSelectedFeatures());
            events.bus.publish(events.eventResetLeftWizardPanels());
            if (self.eventMultipleFeaturesSelectedUnsubscribe) self.eventMultipleFeaturesSelectedUnsubscribe();
            $('[name="additionalLayerInfoBtn"]').css("color", "black");

            $(this).addClass('mapActionSelected');
            $('.ol-layer').css("cursor", "help");;

            self.eventMultipleFeaturesSelectedUnsubscribe = events.bus.subscribe(events.eventMultipleFeaturesSelected, e => {
                //Utilities.GetControl(mainDOMRefs.jqc.featureDetailsPanel).removeClass('show');
                //Utilities.GetControl(mainDOMRefs.jqc.featureDetailsPanel).removeClass('show400');
              
                let data: IFeaturesRequest = { maintCodes: [], infraCodes: [], infraHistoricCodes: [], routeCodes: [], landCodes: [], troGeomIDs: [], legalRoutes: [], legalFeatures: [], annotationGeomIDs: [] };
                e.payload.features.forEach(f => {
                    var p = f.getProperties();
                    if (p.MaintCode != null) {
                        data.maintCodes.push(p.MaintCode);
                    }
                    else if (p.InfraCode != null) {
                        if (p.Historic == 1) data.infraHistoricCodes.push(p.InfraCode);
                        else data.infraCodes.push(p.InfraCode);
                    }
                    else if (p.RouteCode != null) {
                        data.routeCodes.push(p.RouteCode);
                    }
                    else if (p.LandCode != null) {
                        data.landCodes.push(p.LandCode);
                    }
                    else if (p.TROGeomID != null) {
                        data.troGeomIDs.push(p.TROGeomID);
                    }
                    else if (p.TROGeomID != null) {
                        data.troGeomIDs.push(p.TROGeomID);
                    }
                    else if (p.LegalRoute != null) {
                        data.legalRoutes.push(p.LegalRoute);
                    }
                    else if (p.LegalFeature != null) {
                        data.legalFeatures.push(p.LegalFeature);
                    }
                });

                //self.selectList.openSelectListPanel(data);
                self.selectList.openSelectListMapPopup(data, e.payload.point);
                
            });

            var mapInteractionConfig: IMapInteractionConfig = {
                zoomToSelectedFeatures: false, addToExistingSelection: false,
                selectableLayers: [FeatureType.Maint, FeatureType.Infra, FeatureType.InfraHistoric, FeatureType.Route, FeatureType.Land, FeatureType.TRO, FeatureType.LegalEvent, FeatureType.LegalFeature]
            };

            self.mainMap.startLocationInfo(mapInteractionConfig);
        });

        //SEARCH
        Utilities.GetControl(mainDOMRefs.jqc.searchBtn).on("click", function () {
            events.bus.publish(events.eventResetAllButtons(false));
            events.bus.publish(events.eventResetRightPanels());
            //events.bus.publish(events.eventRemoveAllMapInteractions());

            $(this).addClass('mapActionSelected');
            Utilities.GetControl(mainDOMRefs.jqc.searchPanel).addClass('show');
        });

        // Additonal Map Tools
        Utilities.GetControl(mainDOMRefs.jqc.additionalMapToolsBtn).on("click", function () {
            events.bus.publish(events.eventResetAllButtons(false));
            events.bus.publish(events.eventResetRightPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());

            $(this).addClass('mapActionSelected');
            Utilities.GetControl(mainDOMRefs.jqc.additionalMapToolsPanel).addClass('show');
        });
        Utilities.GetControl(mainDOMRefs.jqc.additionalMapToolsCloseBtn).on("click", function () {
            events.bus.publish(events.eventResetAllButtons(false));
            events.bus.publish(events.eventResetRightPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
        });

        // MAP SCALE
        $('#mapScaleSelect').on('change', function () {
            var scale = $(this).children("option:selected").val();
            if ($.isNumeric(scale) == true) self.mainMap.zoomToScale(scale as number);
        });
        
        // REPORT AN ISSUE - MY ISSUES
        Utilities.GetControl(mainDOMRefs.jqc.reportAnIssue_MyIssuesBtn).on("click", function () {
            events.bus.publish(events.eventResetAllButtons(false));
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());

            $(this).addClass('mapActionSelected');
            self.reportAnIssueMyIssues.openMyIssuesPanel();
        });

        // REPORT AN ISSUE - CREATE
        Utilities.GetControl(mainDOMRefs.jqc.reportAnIssue_CreateBtn).on("click", function () { createNewIssue(); });
        Utilities.GetControl(mainDOMRefs.jqc.reportAnIssue_CreateMobileBtn).on("click", function () { createNewIssue(); });

        function createNewIssue() {
            events.bus.publish(events.eventResetAllButtons(false));
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventClearAllHighlights());
            events.bus.publish(events.eventClearSelectedFeatures());

            $(this).addClass('mapActionSelected')
            self.reportAnIssueNewIssue.newMaintWizard_Start(null)
        }

        // OFFICER MAP MAP SELECT
        Utilities.GetControl(mainDOMRefs.jqc.mapTreeSelectBtn).on("click", function () {
            events.bus.publish(events.eventResetAllButtons(false));
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventClearAllHighlights());
            events.bus.publish(events.eventClearSelectedFeatures());
            events.bus.publish(events.eventResetRightPanels());
            if (self.eventMultipleFeaturesSelectedUnsubscribe) self.eventMultipleFeaturesSelectedUnsubscribe();
            if (self.eventRectangleSelectionCompleteUnsubscribe) self.eventRectangleSelectionCompleteUnsubscribe();

            self.eventMultipleFeaturesSelectedUnsubscribe = events.bus.subscribe(events.eventMultipleFeaturesSelected, e => {
                self.officerMapMapSelect.multiSelectionComplete(e.payload.features);
                $('#treeSelectPanel').removeClass('show');
            });
            self.eventRectangleSelectionCompleteUnsubscribe = events.bus.subscribe(events.eventRectangleSelectionComplete, e => {
                self.officerMapMapSelect.rectangleSelectionComplete(e.payload as any);
                $('#treeSelectPanel').removeClass('show');
            });

            $(this).addClass('mapActionSelected');
            self.mainMap.forceReloadSelectedFeaturesLayer();
            self.officerMapMapSelect.openTreeSelectPanel();
        });

        // OFFICER MAP RECORD LIST
        Utilities.GetControl(mainDOMRefs.jqc.recordListBtn).on("click", function () {
            events.bus.publish(events.eventResetAllButtons(false));
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventClearAllHighlights());
            events.bus.publish(events.eventClearSelectedFeatures());

            $(this).addClass('mapActionSelected')
            self.officerMapRecordList.OpenRecordListPanel();
        });

        // OFFICER NEW FEATURE
        Utilities.GetControl(mainDOMRefs.jqc.newFeatureBtn).on("click", function () {
            events.bus.publish(events.eventResetAllButtons(false));
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventClearAllHighlights());
            events.bus.publish(events.eventClearSelectedFeatures());

            $(this).addClass('mapActionSelected')
            Utilities.GetControl(mainDOMRefs.jqc.newFeaturePanel).addClass('show');
        });

        // OFFICER MAP NEW MAINT
        Utilities.GetControl(mainDOMRefs.jqc.newMaintBtn).on('click', function () {
            events.bus.publish(events.eventResetAllButtons(false));
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventClearAllHighlights());
            events.bus.publish(events.eventClearSelectedFeatures());

            $(this).addClass('mapActionSelected')

            // This fires the process off, if it is canceled then it restarts it from the begining
            startProcess();
            function startProcess() { self.maint.newMaintWizard_Start(null, null, function (r) { if (r == NewMapGeometryResult.close) return; if (r == NewMapGeometryResult.restart || r==null) startProcess(); }); }
        });

        // OFFICER MAP  NEW INFRA
        Utilities.GetControl(mainDOMRefs.jqc.newInfraBtn).on('click', function () {
            events.bus.publish(events.eventResetAllButtons(false));
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventClearAllHighlights());
            events.bus.publish(events.eventClearSelectedFeatures());

            $(this).addClass('mapActionSelected')
            
            // This fires the process off, if it is canceled then it restarts it from the begining
            startProcess();
            function startProcess() {
                self.infra.newInfraWizard_Start(null, null, function (r) {
                    if (r == NewMapGeometryResult.close) return;
                    if (r == NewMapGeometryResult.restart || r == false) startProcess();
                });
            }
        });

        // OFFICER MAP  NEW LAND
        Utilities.GetControl(mainDOMRefs.jqc.newLandBtn).on('click', function () {
            events.bus.publish(events.eventResetAllButtons(false));
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventClearAllHighlights());
            events.bus.publish(events.eventClearSelectedFeatures());

            $(this).addClass('mapActionSelected')
            self.land.newLandWizard_Start()
        });

        // OFFICER MAP  NEW ROUTE
        Utilities.GetControl(mainDOMRefs.jqc.newRouteBtn).on('click', function () {
            events.bus.publish(events.eventResetAllButtons(false));
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventClearAllHighlights());
            events.bus.publish(events.eventClearSelectedFeatures());

            $(this).addClass('mapActionSelected')
            self.routes.newRouteWizard_Start(null, false);
        });

        // OFFICER MAP  NEW PATH
        Utilities.GetControl(mainDOMRefs.jqc.newPathBtn).on('click', function () {
            events.bus.publish(events.eventResetAllButtons(false));
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventClearAllHighlights());
            events.bus.publish(events.eventClearSelectedFeatures());

            $(this).addClass('mapActionSelected')
            self.path.openCreatePanel();
        });

        // OFFICER MAP NEW TASK
        Utilities.GetControl(mainDOMRefs.jqc.newTaskBtn).on('click', function () {
            events.bus.publish(events.eventResetAllButtons(false));
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventClearAllHighlights());
            events.bus.publish(events.eventClearSelectedFeatures());

            $(this).addClass('mapActionSelected')
            self.tasks.newTaskWizard_Start($('#newTask_Message1').data('allow-land'));
        });
        Utilities.GetControl(mainDOMRefs.jqc.newTaskBtnOnTasks).on('click', function () {
            events.bus.publish(events.eventResetAllButtons(false));
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventClearAllHighlights());
            events.bus.publish(events.eventClearSelectedFeatures());

            $(this).addClass('mapActionSelected')
            self.tasks.newTaskWizard_Start($('#newTask_Message1').data('allow-land'));
        });

        Utilities.GetControl(mainDOMRefs.jqc.contactsBtn).on('click', function () {
            let btns = new ContactListConfig(); btns.ActionBtns.use.visible = false;
            Utilities.GetCollapse(mainDOMRefs.jqc.navbarNavDropdown, CollapseAction.Hide);
            //setTimeout(function () { Utilities.GetControl(mainDOMRefs.jqc.navbarNavDropdown).removeClass('mainAppTopRightMenuHeaderPanelContainer'); }, 500);
            events.bus.publish(events.eventOpenContactsListView([false, btns, null]));
        });
        

        // ANNOTATIONS NEW
        Utilities.GetControl(mainDOMRefs.jqc.annotationsNewBtn).on("click", function () {
            events.bus.publish(events.eventResetAllButtons(false));
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventClearAllHighlights());
            events.bus.publish(events.eventClearSelectedFeatures());
      
            $(this).addClass('mapActionSelected')
            self.annotations.selectFeatureThenCreateNewAnnotationSet();
        });

        // MY TASKS RECORD LIST
        Utilities.GetControl(mainDOMRefs.jqc.myTasksRecordListBtn).on("click", function () {
            events.bus.publish(events.eventResetAllButtons(false));
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventClearAllHighlights());
            events.bus.publish(events.eventClearSelectedFeatures());

            $(this).addClass('mapActionSelected')
            events.bus.publish(events.eventOpenMyTasksRecordListPanel());
        });

        // TASK MANAGEMENT RECORD LIST
        Utilities.GetControl(mainDOMRefs.jqc.taskManagementRecordListBtn).on("click", function () {
            events.bus.publish(events.eventResetAllButtons(false));
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventClearAllHighlights());
            events.bus.publish(events.eventClearSelectedFeatures());

            $(this).addClass('mapActionSelected')
            self.taskManagementRecordList.OpenRecordListPanel();
        });

        // SUBMISSION LIST
        Utilities.GetControl(mainDOMRefs.jqc.submissionListPanelBtn).on("click", function () {
            events.bus.publish(events.eventResetAllButtons(false));
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventClearAllHighlights());
            events.bus.publish(events.eventClearSelectedFeatures());

            $(this).addClass('mapActionSelected')
            self.submissionList.OpenSubmissionListPanel();
        });

        // LEGAL EVENTS LIST
        Utilities.GetControl(mainDOMRefs.jqc.legalEventsBtn).on("click", function () {
            events.bus.publish(events.eventResetAllButtons(false));
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventClearAllHighlights());
            events.bus.publish(events.eventClearSelectedFeatures());

            $(this).addClass('mapActionSelected')
            self.legalEvents.OpenListPanel();
        }); 

        Utilities.GetControl(mainDOMRefs.jqc.newLegalEventsBtn).on("click", function () {
            events.bus.publish(events.eventResetAllButtons(false));
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventClearAllHighlights());
            events.bus.publish(events.eventClearSelectedFeatures());

            $(this).addClass('mapActionSelected')
            self.legalEvents.openCreatePanel();
        });

        // CONSULTATIONS LIST
        Utilities.GetControl(mainDOMRefs.jqc.consultationsBtn).on("click", function () {
            events.bus.publish(events.eventResetAllButtons(false));
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventClearAllHighlights());
            events.bus.publish(events.eventClearSelectedFeatures());

            $(this).addClass('mapActionSelected')
            //self.consultations.OpenListPanel(ConsultationsFilter.All);
            self.consultations.OpenMyConsultations();
        });

        Utilities.GetControl(mainDOMRefs.jqc.consultationsRegisterBtn).on("click", function () {
            events.bus.publish(events.eventResetAllButtons(false));
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventClearAllHighlights());
            events.bus.publish(events.eventClearSelectedFeatures());

            $(this).addClass('mapActionSelected')
            self.consultations.OpenGroupPanel();
        });

        // ANNOTATIONS LIST
        Utilities.GetControl(mainDOMRefs.jqc.annotationsListBtn).on("click", function () {
            events.bus.publish(events.eventResetAllButtons(false));
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventClearAllHighlights());
            events.bus.publish(events.eventClearSelectedFeatures());

            $(this).addClass('mapActionSelected')
            self.annotations.OpenListPanel();
        });

        // ANNOTATIONS REPORT
        Utilities.GetControl(mainDOMRefs.jqc.annotationsReportBtn).on("click", function () {
            events.bus.publish(events.eventResetAllButtons(false));
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            
            $(this).addClass('mapActionSelected')

            var selectedMsg = "Show map area";
            let data: ReportModel = { systemType: SystemType.AnnotationSimpleMap, promptForMap: true };
            events.bus.publish(events.eventOpenReportOrSelectList([data, selectedMsg]));
        });

        // TRO LIST
        Utilities.GetControl(mainDOMRefs.jqc.troListBtn).on("click", function () {
            events.bus.publish(events.eventResetAllButtons(false));
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventClearAllHighlights());
            events.bus.publish(events.eventClearSelectedFeatures());

            $(this).addClass('mapActionSelected')
            self.TRO.OpenListPanel();
        });

        // NEW TRO
        Utilities.GetControl(mainDOMRefs.jqc.troNewBtn).on("click", function () {
            events.bus.publish(events.eventResetAllButtons(false));
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventClearAllHighlights());
            events.bus.publish(events.eventClearSelectedFeatures());

            $(this).addClass('mapActionSelected')
            self.TRO.openCreatePanel();
        });

    }

    private initHeaderButtons = (): void => {
        const self = this;
        var toolbarShown = false;

        // Hide the main menu buttons
        $('#navbarNavDropdown [data-menulink="main"]').hide();
        Utilities.GetControl(mainDOMRefs.jqc.headerHome).show();
        Utilities.GetControl(mainDOMRefs.jqc.headerHome).on('click', function () {
            if (window.G_SITEFOLDERNAME == "") window.location.assign("/");
            else window.location.assign(window.G_SITEFOLDERNAME);
        });

        // Show help button
        Utilities.GetControl(mainDOMRefs.jqc._layoutHeaderHelpIcon).removeClass('d-none');
        self.help.setHelpText(HelpType.Public); // Other help gets shown depending on the toolbar selected

        // Only show the Notifications b utton if in desktop view
        if (G_IsMobile == false) {
            Utilities.GetControl(mainDOMRefs.jqc._layoutHeaderNotifationListIcon).removeClass('d-none');
        }

        if (self.authModel.policies.find(p => p == AuthModel.CAMSReportAnIssue) != null) {
            Utilities.GetControl(mainDOMRefs.jqc.headerReportanIssue).show(); toolbarShown = true;
            Utilities.GetControl(mainDOMRefs.jqc.headerReportanIssue).on('click', function () { reset(); $(this).addClass('selected'); showToolbar('toolbarBtnReportAnIssue'); });
        }

        if (self.authModel.policies.find(p => p == AuthModel.CAMSOfficerMap) != null) {
            Utilities.GetControl(mainDOMRefs.jqc.headerTrustedMap).show(); toolbarShown = true;
            Utilities.GetControl(mainDOMRefs.jqc.headerTrustedMap).on('click', function () { reset(); $(this).addClass('selected'); showToolbar('toolbarBtnTrustedMap'); })
        }

        if (self.authModel.policies.find(p => p == AuthModel.CAMSMyTasks) != null) {
            Utilities.GetControl(mainDOMRefs.jqc.headerMyTasks).show(); toolbarShown = true;
            Utilities.GetControl(mainDOMRefs.jqc.headerMyTasks).on('click', function () { reset(); $(this).addClass('selected'); showToolbar('toolbarBtnMyTasks'); })
        }

        if (self.authModel.policies.find(p => p == AuthModel.CAMSLegal) != null) {
            Utilities.GetControl(mainDOMRefs.jqc.headerConsultations).show(); toolbarShown = true;
            Utilities.GetControl(mainDOMRefs.jqc.headerConsultations).on('click', function () { reset(); $(this).addClass('selected'); showToolbar('toolbarBtnConsultations'); })
        }

        if (self.authModel.policies.find(p => p == AuthModel.CAMSLand) != null) {
            Utilities.GetControl(mainDOMRefs.jqc.headerLand).show(); toolbarShown = true;
            Utilities.GetControl(mainDOMRefs.jqc.headerLand).on('click', function () { toastr.info("To be completed"); })
        }

        if (self.authModel.policies.find(p => p == AuthModel.CAMSAnnotation) != null) {
            Utilities.GetControl(mainDOMRefs.jqc.headerAnnotations).show(); toolbarShown = true;
            Utilities.GetControl(mainDOMRefs.jqc.headerAnnotations).on('click', function () { reset(); $(this).addClass('selected'); showToolbar('toolbarBtnAnnotations'); })
        }

        if (self.authModel.policies.find(p => p == AuthModel.CAMSTRO) != null) {
            Utilities.GetControl(mainDOMRefs.jqc.headerTRO).show(); toolbarShown = true;
            Utilities.GetControl(mainDOMRefs.jqc.headerTRO).on('click', function () { reset(); $(this).addClass('selected'); showToolbar('toolbarBtnTRO'); })
        }

        function reset() {
            Utilities.GetControl(mainDOMRefs.jqc.headerReportanIssue).removeClass('selected');
            Utilities.GetControl(mainDOMRefs.jqc.headerTrustedMap).removeClass('selected')
            Utilities.GetControl(mainDOMRefs.jqc.headerMyTasks).removeClass('selected')
            Utilities.GetControl(mainDOMRefs.jqc.headerTaskManagement).removeClass('selected')
            Utilities.GetControl(mainDOMRefs.jqc.headerSubmissions).removeClass('selected')
            Utilities.GetControl(mainDOMRefs.jqc.headerLegalEvents).removeClass('selected')
            Utilities.GetControl(mainDOMRefs.jqc.headerLand).removeClass('selected')
            Utilities.GetControl(mainDOMRefs.jqc.headerContacts).removeClass('selected')
            Utilities.GetControl(mainDOMRefs.jqc.headerConsultations).removeClass('selected')
            Utilities.GetControl(mainDOMRefs.jqc.headerAnnotations).removeClass('selected')
            Utilities.GetControl(mainDOMRefs.jqc.headerTRO).removeClass('selected')
        }

        function showToolbar(name) {
            self.MainResetEvents.resetLeftPanels();
            Utilities.GetControl(mainDOMRefs.jqc.mainAppToolbar).addClass('hide');
            Utilities.GetCollapse(mainDOMRefs.jqc.navbarNavDropdown, CollapseAction.Hide);
            
            setTimeout(function () { Utilities.GetControl(mainDOMRefs.jqc.navbarNavDropdown).removeClass('mainAppTopRightMenuHeaderPanelContainer'); }, 500);

            setTimeout(function () {
                self.MainResetEvents.resetButtons();
                Utilities.GetControl(mainDOMRefs.jqc.navbarNavSelectedTitle).text('');

                $('[name="toolbarBtnReportAnIssue"]').hide();
                $('[name="toolbarBtnTrustedMap"]').hide();
                $('[name="toolbarBtnMyTasks"]').hide();
                $('[name="toolbarBtnTaskManagement"]').hide();
                $('[name="toolbarBtnSubmissions"]').hide();
                $('[name="toolbarBtnLegal"]').hide();
                $('[name="toolbarBtnConsultations"]').hide();
                $('[name="toolbarBtnAnnotations"]').hide();
                $('[name="toolbarBtnTRO"]').hide();

                $('[name="' + name + '"]').show();

                self.selectList.setVisibleButtons(self.defaultSelectListButtons);
                let localStorageSettings: LocalStorageSettingsModel = JSON.parse(window.localStorage.getItem('localStorageSettings'));
                switch (name) {
                    case 'toolbarBtnReportAnIssue':
                        Utilities.GetControl(mainDOMRefs.jqc.navbarNavSelectedTitle).text(Utilities.GetControl(mainDOMRefs.jqc.headerReportanIssue).text());
                        localStorageSettings.StartHeaderBtn = 'headerReportanIssue';
                        self.help.setHelpText(HelpType.ReportAnIssue);
                        Utilities.GetControl(mainDOMRefs.jqc.reportAnIssue_MyIssuesBtn).click(); 
                        Utilities.GetControl(mainDOMRefs.jqc.mapInfoSelectBtn).click();
                        break;
                    case 'toolbarBtnTrustedMap':
                        Utilities.GetControl(mainDOMRefs.jqc.navbarNavSelectedTitle).text(Utilities.GetControl(mainDOMRefs.jqc.headerTrustedMap).text());
                        localStorageSettings.StartHeaderBtn = 'headerTrustedMap';
                        self.help.setHelpText(HelpType.TrustedMap);
                        Utilities.GetControl(mainDOMRefs.jqc.annotationsNewBtn).hide(); // hide this button
                        //Utilities.GetControl(mainDOMRefs.jqc.annotationsReportBtn).show(); // show this button
                        Utilities.GetControl(mainDOMRefs.jqc.mapInfoSelectBtn).click();
                        break;
                    case 'toolbarBtnMyTasks':
                        Utilities.GetControl(mainDOMRefs.jqc.navbarNavSelectedTitle).text(Utilities.GetControl(mainDOMRefs.jqc.headerMyTasks).text());
                        localStorageSettings.StartHeaderBtn = 'headerMyTasks';
                        Utilities.GetControl(mainDOMRefs.jqc.newTaskBtnOnTasks).show(); // Also show this button on the My tasks form
                        self.help.setHelpText(HelpType.MyTasks);
                        Utilities.GetControl(mainDOMRefs.jqc.myTasksRecordListBtn).click();
                        Utilities.GetControl(mainDOMRefs.jqc.mapInfoSelectBtn).click();
                        break;
                    case 'toolbarBtnConsultations':
                        Utilities.GetControl(mainDOMRefs.jqc.navbarNavSelectedTitle).text(Utilities.GetControl(mainDOMRefs.jqc.headerConsultations).text());
                        localStorageSettings.StartHeaderBtn = 'headerConsultations';
                        self.help.setHelpText(HelpType.Consultations);

                        // Auto click the legal events btn, but if that is not available then click the consultations btn
                        if (Utilities.GetControl(mainDOMRefs.jqc.legalEventsBtn).length > 0) Utilities.GetControl(mainDOMRefs.jqc.legalEventsBtn).click();
                        else Utilities.GetControl(mainDOMRefs.jqc.consultationsRegisterBtn).click();

                        Utilities.GetControl(mainDOMRefs.jqc.mapInfoSelectBtn).click();
                        break;
                    case 'toolbarBtnAnnotations':
                        Utilities.GetControl(mainDOMRefs.jqc.navbarNavSelectedTitle).text(Utilities.GetControl(mainDOMRefs.jqc.headerAnnotations).text());
                        localStorageSettings.StartHeaderBtn = 'headerAnnotations';
                        self.help.setHelpText(HelpType.Annotations);
                        Utilities.GetControl(mainDOMRefs.jqc.annotationsNewBtn).show(); // Also show this button
                        self.selectList.setVisibleButtons({ showMapHighlightBtn: true, showMapEditBtn: true, showAddSelectionBtn: false, showDetailsBtn: true, showEditAttributeBtn: true, showAnnotationBtn: true, showDeleteBtn: true });
                        Utilities.GetControl(mainDOMRefs.jqc.annotationsListBtn).click();
                        Utilities.GetControl(mainDOMRefs.jqc.mapInfoSelectBtn).click();
                        break;
                    case 'toolbarBtnTRO':
                        Utilities.GetControl(mainDOMRefs.jqc.navbarNavSelectedTitle).text(Utilities.GetControl(mainDOMRefs.jqc.headerTRO).text());
                        localStorageSettings.StartHeaderBtn = 'headerTRO';
                        self.help.setHelpText(HelpType.TRO);
                        events.bus.publish(events.eventSetVisibleMapLayer([FeatureType.TRO, true]));
                        //Utilities.GetControl(mainDOMRefs.jqc.mapTreeSelectBtn).show(); // Also show this button on the legal form
                        Utilities.GetControl(mainDOMRefs.jqc.recordListBtn).show(); // Also show this button on the legal form
                        Utilities.GetControl(mainDOMRefs.jqc.troListBtn).click();
                        Utilities.GetControl(mainDOMRefs.jqc.mapInfoSelectBtn).click();
                        break;
                }
                window.localStorage.setItem('localStorageSettings', JSON.stringify(localStorageSettings));

                // Show the toolbar
                Utilities.GetControl(mainDOMRefs.jqc.mainAppToolbar).removeClass('hide');

                // Now fire the call back 
                events.bus.publish(events.eventMainPageLoadComplete());
            }, 500);
        }

        //If no toolbar is opened, make sure this is fired
        if (toolbarShown == false) setTimeout(function () { events.bus.publish(events.eventMainPageLoadComplete()); }, 500);

        // Set the starting button
        let localStorageSettings: LocalStorageSettingsModel = JSON.parse(window.localStorage.getItem('localStorageSettings'));
        if ($('#' + localStorageSettings.StartHeaderBtn).is(":visible") == true) {
            $('#' + localStorageSettings.StartHeaderBtn).click();
        }
        else {
            Utilities.GetControl(mainDOMRefs.jqc.headerReportanIssue).click();
        }
        
    }

    private initLocalStorage = (): void => {
        const self = this; 

        // Check the ocal settings, if they do not exist create them
        let localStorageSettings: LocalStorageSettingsModel;
        let localStorageSettings_str = window.localStorage.getItem('localStorageSettings');
        if (localStorageSettings_str == null) {
            localStorageSettings = {
                Version: self.mainAppConfigModel.mapConfig.version,
                MapInitialState: self.mainAppConfigModel.mapConfig.mapInitialState,
                StartHeaderBtn: 'headerReportanIssue',
                HelpText: { AutoShow: true, PosX: null, PosY: null },
                Layers: []
            };
            window.localStorage.setItem('localStorageSettings', JSON.stringify(localStorageSettings));
        }
        else {
            localStorageSettings = JSON.parse(localStorageSettings_str);
        }

        // If they do exist, check they are the right version. If not, reset them
        if (localStorageSettings.Version != self.mainAppConfigModel.mapConfig.version) {
            localStorageSettings.Version = self.mainAppConfigModel.mapConfig.version;
            localStorageSettings.MapInitialState = self.mainAppConfigModel.mapConfig.mapInitialState;
            window.localStorage.setItem('localStorageSettings', JSON.stringify(localStorageSettings));
        }
    }

    // ----------------------------------------------------------- //
    // Calculate the window height in resize
    private resizeMainContentDiv = (): void => {
        var self = this;
        var bodyHeight = $('body').outerHeight();
        var headerHeight = $('#mainHeader').outerHeight();
        var footerHeight = $('#mainFooter').outerHeight();
        var toolbarHeight = Utilities.GetControl(mainDOMRefs.jqc.CAMSMainToolbar_Container).outerHeight();

        // Only change the toolbar height it it is NOT in mobile mode
        if (window.matchMedia("(max-width: 768px)").matches == false) {
            Utilities.GetControl(mainDOMRefs.jqc.CAMSMainPage_LeftPanels).css({ top: headerHeight + "px", bottom: "0px" });
            Utilities.GetControl(mainDOMRefs.jqc.CAMSMainPage_RightPanels).css({ top: headerHeight + "px", bottom: "0px" });
            Utilities.GetControl(mainDOMRefs.jqc.officerMapContainer).css({ top: headerHeight + "px", height: bodyHeight - headerHeight + "px" });

            Utilities.GetControl(mainDOMRefs.jqc.CAMSMainToolbar_Container).css({ top: headerHeight + "px", bottom: "0px" });
            //$('#CAMSMainPage').css({ top: headerHeight + "px", bottom: "0px" }); // Resize the main content window also
        }
        else {
            Utilities.GetControl(mainDOMRefs.jqc.CAMSMainToolbar_Container).css({ top: 'unset', bottom: "0px" });
            Utilities.GetControl(mainDOMRefs.jqc.officerMapContainer).css({ top: headerHeight + "px", height: bodyHeight - headerHeight - toolbarHeight +10 + "px" });

            $('main').css('padding', 'unset');
        }

        if ($('[data-camsmenutoggle]').is(':visible') == true ) Utilities.GetControl(mainDOMRefs.jqc.navbarNavSelectedTitle).show();
        else Utilities.GetControl(mainDOMRefs.jqc.navbarNavSelectedTitle).hide();

        setTimeout(function () { self.mainMap.map.updateSize(); }, 200);
    }

    // ----------------------------------------------------------- //
    // Main Page actions based on the URL request (e.g. INFO, EDIT, etc)

    private onMainPageLoadCompleted = (): void => {
        const self = this;

        if (self.mainAppConfigModel.openInfoPanel != null) {
            if (self.mainAppConfigModel.openInfoPanel.camsKey != null) {
                self.openSelectListWithFeature(self.mainAppConfigModel.openInfoPanel);
                self.mainAppConfigModel.openInfoPanel = null; // reset here so it doesn't keep firing

                // Update display URL
                var url = "/map"; if (window.location.href.indexOf('/cy/') != -1) url = "/cy/map";
                history.pushState(null, null, url);
            }
            else {
                Utilities.GetControl(mainDOMRefs.jqc.placeholder_for_modals).load(window.G_SITEFOLDERNAME + '/SelectList/CannotFindFeatureView', { requestCode: self.mainAppConfigModel.openInfoPanel.requestCode }, function (response, status, xhr) {
                    Utilities.GetModal(mainDOMRefs.jqc.selectListCannotFindFeatureModal, ModalAction.Create);
                });
            }
        }

    }

    private openSelectListWithFeature = (openInfoPanel: OpenInfoPanel): void => {
        const self = this;
  
        if (openInfoPanel.camsKey.featureType == FeatureType.LegalConsultation) {
            events.bus.publish(events.eventOpenLegalConsultationDetailsPanel(openInfoPanel.camsKey));
        }
        else if (openInfoPanel.camsKey.featureType == FeatureType.LegalEvent) {
            events.bus.publish(events.eventOpenLegalEventsEditPanel(openInfoPanel.camsKey));
        }
        else {
            let data = { maintCodes: [], infraCodes: [], infraHistoricCodes: [], routeCodes: [], landCodes: [], troGeomIDs: [] };
            switch (openInfoPanel.camsKey.featureType) {
                case FeatureType.Maint:
                    data.maintCodes.push(openInfoPanel.camsKey.code);
                    break;
                case FeatureType.Route:
                    data.routeCodes.push(openInfoPanel.camsKey.code);
                    break;
                case FeatureType.Infra:
                    data.infraCodes.push(openInfoPanel.camsKey.code);
                    break;
                case FeatureType.InfraHistoric:
                    data.infraHistoricCodes.push(openInfoPanel.camsKey.code);
                    break;
                case FeatureType.Land:
                    data.landCodes.push(openInfoPanel.camsKey.code);
                    break;
                case FeatureType.TRO:
                    data.troGeomIDs.push(openInfoPanel.camsKey.code);
                    break;
                case FeatureType.Task:
                    if (openInfoPanel.camsKey.parentFeatureType == FeatureType.Maint) data.maintCodes.push(openInfoPanel.camsKey.parentCode);
                    else if (openInfoPanel.camsKey.parentFeatureType == FeatureType.Infra) data.infraCodes.push(openInfoPanel.camsKey.parentCode);
                    else if (openInfoPanel.camsKey.parentFeatureType == FeatureType.Route) data.routeCodes.push(openInfoPanel.camsKey.parentCode);
                    else if (openInfoPanel.camsKey.parentFeatureType == FeatureType.Land) data.landCodes.push(openInfoPanel.camsKey.parentCode);
                    break;
            }
  
            self.selectList.openSelectListPanel(data);
            events.bus.publish(events.eventZoomToWKTandHighlight([[openInfoPanel.camsKey.wkt], true, true, openInfoPanel.camsKey.featureType]));
        }
    }

    private openMainMenu = (menuType: MenuType): void => {
        const self = this;
      
        let localStorageSettings: LocalStorageSettingsModel = JSON.parse(window.localStorage.getItem('localStorageSettings'));
        switch (menuType) {
            case MenuType.rai:
                if (Utilities.GetControl(mainDOMRefs.jqc.headerReportanIssue).css('visibility') === 'visible') {
                    localStorageSettings.StartHeaderBtn = 'headerReportanIssue';
                }
                break;
            case MenuType.om:
                if (Utilities.GetControl(mainDOMRefs.jqc.headerTrustedMap).css('visibility') === 'visible') {
                    localStorageSettings.StartHeaderBtn = 'headerTrustedMap';
                }
                break;
            case MenuType.mt:
                if (Utilities.GetControl(mainDOMRefs.jqc.headerMyTasks).css('visibility') === 'visible') {
                    localStorageSettings.StartHeaderBtn = 'headerMyTasks';
                }
                break;
            case MenuType.tm:
                if (Utilities.GetControl(mainDOMRefs.jqc.headerTaskManagement).css('visibility') === 'visible') {
                    localStorageSettings.StartHeaderBtn = 'headerTaskManagement';
                }
                break;
            case MenuType.sub:
                if (Utilities.GetControl(mainDOMRefs.jqc.headerSubmissions).css('visibility') === 'visible') {
                    localStorageSettings.StartHeaderBtn = 'headerSubmissions';
                }
                break;
            case MenuType.ann:
                if (Utilities.GetControl(mainDOMRefs.jqc.headerAnnotations).css('visibility') === 'visible') {
                    localStorageSettings.StartHeaderBtn = 'headerAnnotations';
                }
                break;
            case MenuType.le:
                if (Utilities.GetControl(mainDOMRefs.jqc.headerAnnotations).css('visibility') === 'visible') {
                    localStorageSettings.StartHeaderBtn = 'headerLegalEvents';
                }
                break;
            //case MenuType.con:
            //    if (Utilities.GetControl(mainDOMRefs.jqc.headerContacts).css('visibility') === 'visible') {
            //        localStorageSettings.StartHeaderBtn = 'headerContacts';
            //    }
                break;

            default:

                break;
        }
        window.localStorage.setItem('localStorageSettings', JSON.stringify(localStorageSettings));

        // Update display URL
        var url = "/map"; if (window.location.href.indexOf('/cy/') != -1) url = "/cy/map";
        history.pushState(null, null, url);
    }

}




